import Icon from "../core/ui/atoms/Icon";

interface PaymentMethodBackButtonProps {
  onClick: () => void;
  children: React.ReactNode;
}

export const PaymentMethodBackButton: React.FC<PaymentMethodBackButtonProps> = ({ onClick, children }) => (
  <button className="btn" onClick={onClick}>
    <span className="method-name">
      <span className="method-back-icon">
        <Icon name="chevronLeft" size={14} color="var(--primary-text)" />
      </span>
      {children}
    </span>
  </button>
);
